export class FocusDirective implements angular.IDirective {
    restrict = 'A';
    scope = {
        focus: '=focus'
    };

    link = (scope: angular.IScope, element: angular.IAugmentedJQuery) => {
        scope.$watch('focus', (value) => {
            if (value === true) {
                // Must use timeout to give UI time to set focus.
                this._$timeout(() => { element[0].focus()}, 250);
            }
        });
    };

    constructor(private _$timeout: angular.ITimeoutService) {
    }

    static factory(): angular.IDirectiveFactory {
        const directive = ($timeout) => new FocusDirective($timeout);
        directive.$inject = ['$timeout'];
        return directive;
    }
}

angular.module('deliveryCreate.app').directive('focus', FocusDirective.factory());



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/directives/focus/focusDirective.ts
 **/